import styled from "@emotion/styled";

import ImagePlusFlag from "./img-plus.svg";

export const StyledTopicPlusFlag = styled(ImagePlusFlag)`
  inline-size: 30.75px;
  block-size: 13.5px;
  margin-block-end: 7px;
  margin-inline-end: 8px;

  cursor: pointer;
`;

export const StyledAuthorPlusFlag = styled(ImagePlusFlag)`
  margin-block-end: 12px;

  cursor: pointer;
`;
